import { Button, Checkbox, CheckboxGroup, Divider, Input, Select, Stack } from '@chakra-ui/react';
import { AccountType } from '@pelicargo/types';
import { accountTypeOptions } from '@pelicargo/utils';
import { ChangeEvent, useCallback, useState } from 'react';
import { HiChevronLeft } from 'react-icons/hi';

import { trpc } from '../../config/trpc';
import { RequestFilters } from '../../hooks/useRequestFilters';

const ALL_ACCOUNT_TYPES = 'All';
const options = [{ label: 'All', value: ALL_ACCOUNT_TYPES }, ...accountTypeOptions];

type Props = {
  filters: RequestFilters;
  handleCheckboxFilterChange: (key: string) => (nextValue: string[]) => void;
  resetView: () => void;
};

export const AccountsFilter = ({ filters, handleCheckboxFilterChange, resetView }: Props) => {
  const [query, setQuery] = useState('');
  const [accountType, setAccountType] = useState<AccountType | typeof ALL_ACCOUNT_TYPES>(ALL_ACCOUNT_TYPES);
  const isAllAccountTypes = accountType === ALL_ACCOUNT_TYPES;
  const { data } = trpc.getAccounts.useQuery({
    take: 10,
    skip: 0,
    search: query,
    filters: { type: isAllAccountTypes ? undefined : { equals: accountType } },
  });

  const localOnChange = useCallback(
    (nextValue: string[]) => {
      const finalValue = nextValue?.map((v) => Number(v));
      handleCheckboxFilterChange('account_id')(finalValue as any);
    },
    [handleCheckboxFilterChange],
  );

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setQuery(event.target.value);
  };

  const handleAccountTypeChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const selected = accountTypeOptions.find((option) => option.value === event.target.value);
    setAccountType(selected?.value ?? ALL_ACCOUNT_TYPES);
  };

  // TODO: retype during admin typings project
  const renderItem = useCallback((node: any) => {
    return (
      <Checkbox key={node?.id} value={node?.id}>
        {node?.name}
      </Checkbox>
    );
  }, []);

  return (
    <Stack spacing="2" pt="2">
      <Stack direction="row" align="center" spacing="2">
        <Button variant="ghost" textStyle="label" size="xs" leftIcon={<HiChevronLeft />} onClick={resetView}>
          Accounts
        </Button>
      </Stack>
      <Input size="sm" placeholder="Search accounts by name" value={query} onChange={handleInputChange} />

      <Select value={accountType} onChange={handleAccountTypeChange} size="sm">
        {options.map((type) => (
          <option key={type.value} value={type.value}>
            {type.label}
          </option>
        ))}
      </Select>
      <Divider />

      <CheckboxGroup value={filters.account_id} onChange={localOnChange}>
        {data?.[1]?.map(renderItem)}
      </CheckboxGroup>
    </Stack>
  );
};
